import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../App";
import { api } from "../api";
import { I } from "../Icons";
import { PageHeader, Btn, FieldLabel, Input, SectionLabel, Spinner, MRow, SideNavItem } from "../ui";

function useViewport() {
  const [vw, setVw] = useState(window.innerWidth);
  useEffect(() => { const fn=()=>setVw(window.innerWidth); window.addEventListener("resize",fn); return()=>window.removeEventListener("resize",fn); }, []);
  return { isMobile:vw<600, isDesktop:vw>=960 };
}

export default function MasterDashboard() {
  const { token, logout, T, dark, toggleDark, toast } = useAuth();
  const { isMobile, isDesktop } = useViewport();
  const [agendas,  setAgendas]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [view,     setView]     = useState("list"); // list | create | edit | users
  const [selected, setSelected] = useState(null);
  const [menuOpen, setMenu]     = useState(false);
  const px = isMobile ? 16 : 24;

  async function load() {
    setLoading(true);
    try { setAgendas(await api.getAgendas(token)); }
    catch { toast("Erro ao carregar agendas"); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  function openEdit(ag) { setSelected(ag); setView("edit"); }
  function openUsers(ag) { setSelected(ag); setView("users"); }

  async function handleDelete(id) {
    if (!window.confirm("Remover esta agenda e todos os seus dados?")) return;
    try { await api.deleteAgenda(id, token); toast("Agenda removida"); load(); }
    catch(e) { toast(e.message); }
  }

  const origin = window.location.origin;

  return (
    <div style={{ fontFamily:"'Inter','Helvetica Neue',Arial,sans-serif", background:T.bg, minHeight:"100vh", color:T.text }}>
      {/* HEADER */}
      <header style={{ background:T.header, height:52, display:"flex", alignItems:"center", justifyContent:"space-between", padding:`0 ${isMobile?12:20}px`, position:"sticky", top:0, zIndex:50, boxShadow:`0 2px 10px ${T.shadow}` }}>
        {!isDesktop && <button onClick={()=>setMenu(o=>!o)} style={ib(T)}><I n="Menu" size={20} /></button>}
        <span style={{ color:T.headerText, fontWeight:800, fontSize:isMobile?12:14, letterSpacing:1.5 }}>MASTER ADMIN</span>
        <div style={{ display:"flex", gap:4 }}>
          <button onClick={toggleDark} style={ib(T)}><I n={dark?"Sun":"Moon"} size={17} /></button>
        </div>
      </header>

      <div style={{ display:"flex", maxWidth:isDesktop?1100:"100%", margin:"0 auto" }}>
        {/* DESKTOP SIDEBAR */}
        {isDesktop && (
          <aside style={{ width:220, flexShrink:0, background:T.surface, borderRight:`1px solid ${T.border}`, minHeight:"calc(100vh - 52px)", position:"sticky", top:52, height:"calc(100vh - 52px)", display:"flex", flexDirection:"column" }}>
            <div style={{ padding:"16px 0 8px" }}>
              <SideNavItem icon="Grid"  label="Agendas"       T={T} active={view==="list"}   onClick={()=>{ setView("list"); setSelected(null); }} />
              <SideNavItem icon="Plus"  label="Nova agenda"   T={T} active={view==="create"} onClick={()=>{ setView("create"); setSelected(null); }} />
            </div>
            <div style={{ marginTop:"auto", borderTop:`1px solid ${T.border}`, padding:"12px 18px" }}>
              <button onClick={logout} style={{ display:"flex", alignItems:"center", gap:8, background:"none", border:"none", cursor:"pointer", color:T.danger, fontSize:13, fontWeight:600, padding:"6px 0" }}>
                <I n="Logout" size={15} style={{ color:T.danger }} /> Sair
              </button>
            </div>
          </aside>
        )}

        <main style={{ flex:1, minWidth:0 }}>
          {loading ? <Spinner T={T} /> : (
            <>
              {view === "list"   && <AgendaList   T={T} agendas={agendas} origin={origin} onEdit={openEdit} onUsers={openUsers} onDelete={handleDelete} onNew={()=>setView("create")} isMobile={isMobile} px={px} />}
              {view === "create" && <AgendaForm   T={T} token={token} toast={toast} onDone={()=>{ load(); setView("list"); }} onBack={()=>setView("list")} isMobile={isMobile} px={px} />}
              {view === "edit"   && <AgendaForm   T={T} token={token} toast={toast} agenda={selected} onDone={()=>{ load(); setView("list"); }} onBack={()=>setView("list")} isMobile={isMobile} px={px} />}
              {view === "users"  && <UsersPanel   T={T} token={token} toast={toast} agenda={selected} onBack={()=>setView("list")} isMobile={isMobile} px={px} />}
            </>
          )}
        </main>
      </div>

      {/* MOBILE MENU */}
      {!isDesktop && menuOpen && (
        <div style={{ position:"fixed", inset:0, background:T.modalBg, zIndex:100 }} onClick={()=>setMenu(false)}>
          <div style={{ position:"absolute", top:0, left:0, width:240, height:"100%", background:T.surface, boxShadow:`4px 0 24px ${T.shadowMd}`, display:"flex", flexDirection:"column" }} onClick={e=>e.stopPropagation()}>
            <div style={{ background:T.header, padding:"14px 16px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
              <span style={{ color:T.headerText, fontWeight:800, fontSize:11, letterSpacing:2 }}>ADMIN</span>
              <button onClick={()=>setMenu(false)} style={ib(T)}><I n="X" size={17} /></button>
            </div>
            <div style={{ flex:1, padding:"8px 0" }}>
              <MRow icon="Grid"  label="Agendas"     T={T} onClick={()=>{ setView("list");   setSelected(null); setMenu(false); }} />
              <MRow icon="Plus"  label="Nova agenda" T={T} onClick={()=>{ setView("create"); setSelected(null); setMenu(false); }} />
              <div style={{ height:1, background:T.border, margin:"8px 0" }} />
              <MRow icon={dark?"Sun":"Moon"} label={dark?"Tema claro":"Tema escuro"} T={T} onClick={()=>{ toggleDark(); setMenu(false); }} />
              <div style={{ height:1, background:T.border, margin:"8px 0" }} />
              <MRow icon="Logout" label="Sair" T={T} color={T.danger} onClick={()=>{ logout(); setMenu(false); }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Agenda List ───────────────────────────────────────────────────────────────
function AgendaList({ T, agendas, origin, onEdit, onUsers, onDelete, onNew, isMobile, px }) {
  return (
    <div style={{ padding:`0 0 60px` }}>
      <div style={{ background:T.surface, padding:`14px ${px}px 12px`, borderBottom:`1px solid ${T.border}`, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div>
          <div style={{ fontSize:10, fontWeight:700, color:T.textMuted, letterSpacing:2, textTransform:"uppercase" }}>Painel Master</div>
          <div style={{ fontSize:18, fontWeight:900, color:T.text }}>Agendas ({agendas.length})</div>
        </div>
        <Btn T={T} variant="primary" style={{ padding:"9px 14px", fontSize:12 }} onClick={onNew}><I n="Plus" size={15} /> Nova agenda</Btn>
      </div>

      {agendas.length === 0 ? (
        <div style={{ textAlign:"center", padding:"60px 24px", color:T.textMuted }}>
          <I n="Music" size={40} style={{ color:T.border, marginBottom:12 }} />
          <div style={{ fontSize:15, fontWeight:600, color:T.textSub }}>Nenhuma agenda criada</div>
          <div style={{ fontSize:13, marginTop:6 }}>Crie a primeira agenda para comecar.</div>
        </div>
      ) : (
        <div style={{ padding:`12px ${px}px` }}>
          {agendas.map(ag => {
            const logoUrl = ag.logo_url ? (ag.logo_url.startsWith("http") ? ag.logo_url : `${process.env.REACT_APP_API_URL||""}${ag.logo_url}`) : null;
            const link = `${origin}/${ag.slug}`;
            const loginLink = `${origin}/${ag.slug}/login`;
            return (
              <div key={ag.id} style={{ background:T.surface, borderRadius:12, padding:"14px 16px", marginBottom:10, border:`1px solid ${T.border}`, boxShadow:`0 1px 6px ${T.shadow}` }}>
                <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:10 }}>
                  {logoUrl
                    ? <img src={logoUrl} alt="" style={{ width:40, height:40, borderRadius:8, objectFit:"cover", flexShrink:0 }} />
                    : <div style={{ width:40, height:40, borderRadius:8, background:T.surfaceAlt, border:`1px solid ${T.border}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}><I n="Music" size={20} style={{ color:T.textMuted }} /></div>
                  }
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:15, fontWeight:800, color:T.text }}>{ag.name}</div>
                    <div style={{ fontSize:11, color:T.textMuted }}>/{ag.slug} · {ag.eventCount} shows · {ag.users?.length} usuarios</div>
                  </div>
                </div>

                {/* Links */}
                <div style={{ background:T.surfaceAlt, borderRadius:8, padding:"8px 10px", marginBottom:10 }}>
                  <div style={{ fontSize:10, fontWeight:700, color:T.textMuted, letterSpacing:0.8, marginBottom:4 }}>LINKS DE ACESSO</div>
                  <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:3 }}>
                    <span style={{ fontSize:11, color:T.accent, fontFamily:"monospace", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flex:1 }}>{loginLink}</span>
                    <button onClick={()=>navigator.clipboard.writeText(loginLink).then(()=>{})} style={{ background:"none", border:"none", cursor:"pointer", color:T.textMuted, display:"flex", flexShrink:0, padding:2 }}><I n="Copy" size={12} /></button>
                  </div>
                </div>

                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  <Btn T={T} variant="secondary" style={{ flex:1, fontSize:12, padding:"8px 10px" }} onClick={()=>onEdit(ag)}><I n="Edit" size={13} /> Editar</Btn>
                  <Btn T={T} variant="secondary" style={{ flex:1, fontSize:12, padding:"8px 10px" }} onClick={()=>onUsers(ag)}><I n="Users" size={13} /> Usuarios</Btn>
                  <Btn T={T} variant="danger"    style={{ fontSize:12, padding:"8px 10px" }} onClick={()=>onDelete(ag.id)}><I n="Trash" size={13} /></Btn>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Agenda Form (create / edit) ───────────────────────────────────────────────
function AgendaForm({ T, token, toast, agenda, onDone, onBack, isMobile, px }) {
  const isEdit = !!agenda;
  const [name,     setName]    = useState(agenda?.name || "");
  const [slug,     setSlug]    = useState(agenda?.slug || "");
  const [adminU,   setAdminU]  = useState("");
  const [adminP,   setAdminP]  = useState("");
  const [logoUrl,  setLogoUrl] = useState(agenda?.logo_url || "");
  const [icalUrl,  setIcalUrl] = useState(agenda?.ical_url || "");
  const [saving,   setSaving]  = useState(false);
  const [syncing,  setSyncing] = useState(false);
  const [err,      setErr]     = useState("");
  const fileRef = useRef();

  function handleLogoFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { setErr("Escolha uma imagem PNG, JPG ou WEBP"); return; }
    // D1 limita cada valor a 2 MB. 1 MB deixa folga para a conversão em base64.
    if (file.size > 1024 * 1024) { setErr("O logo deve ter no máximo 1 MB"); return; }
    const reader = new FileReader();
    reader.onload = () => { setLogoUrl(String(reader.result)); setErr(""); };
    reader.readAsDataURL(file);
  }
  function autoSlug(v) {
    if (!isEdit) setSlug(v.toLowerCase().replace(/\s+/g,"-").replace(/[^a-z0-9-]/g,""));
  }

  async function save() {
    if (!name || !slug) { setErr("Nome e slug sao obrigatorios"); return; }
    if (!isEdit && (!adminU || !adminP)) { setErr("Usuario e senha do admin sao obrigatorios"); return; }
    setErr(""); setSaving(true);
    try {
      const payload = { name, slug, logoUrl, icalUrl };
      if (!isEdit) { payload.adminUsername = adminU; payload.adminPassword = adminP; }
      if (isEdit) await api.updateAgenda(agenda.id, payload, token);
      else await api.createAgenda(payload, token);
      toast(isEdit ? "Agenda atualizada" : "Agenda criada");
      onDone();
    } catch(e) { setErr(e.message || "Erro ao salvar"); }
    finally { setSaving(false); }
  }

  async function syncNow() {
    if (!agenda?.slug) return;
    setSyncing(true); setErr("");
    try {
      const result = await api.syncIcal(agenda.slug, token);
      toast(`${result.count} evento(s) importado(s) do Google Agenda`);
    } catch (e) { setErr(e.message || "Não foi possível sincronizar"); }
    finally { setSyncing(false); }
  }

  const inp = { T, style:{ marginBottom:4 } };

  return (
    <div style={{ paddingBottom:60 }}>
      <PageHeader T={T} onBack={onBack} title={isEdit?"Editar Agenda":"Nova Agenda"} px={px} />
      <div style={{ padding:`0 ${px}px 24px` }}>
        {err && <div style={{ background:"rgba(211,47,47,0.1)", border:`1px solid ${T.danger}`, borderRadius:8, padding:"8px 12px", margin:"12px 0", fontSize:12, color:T.danger }}>{err}</div>}

        <SectionLabel T={T}>Identidade</SectionLabel>

        <FieldLabel T={T}>Logo da banda / artista</FieldLabel>
        <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:8 }}>
          <div onClick={()=>fileRef.current?.click()} style={{ width:64, height:64, borderRadius:12, background:T.surfaceAlt, border:`2px dashed ${T.inputBorder}`, display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden", cursor:"pointer", flexShrink:0 }}>
            {logoUrl ? <img src={logoUrl} alt="Prévia do logo" style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : <I n="Image" size={24} style={{ color:T.textMuted }} />}
          </div>
          <div>
            <Btn T={T} variant="secondary" style={{ fontSize:12, padding:"8px 12px" }} onClick={()=>fileRef.current?.click()}><I n="Image" size={13} /> {logoUrl?"Trocar logo":"Enviar logo"}</Btn>
            <div style={{ fontSize:11, color:T.textMuted, marginTop:5 }}>PNG, JPG ou WEBP, até 1 MB.</div>
          </div>
        </div>
        <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp" style={{ display:"none" }} onChange={handleLogoFile} />

        <FieldLabel T={T}>Nome *</FieldLabel>
        <Input {...inp} placeholder="Ex: Planta e Raiz" value={name} onChange={e=>{ setName(e.target.value); autoSlug(e.target.value); }} />

        <FieldLabel T={T}>Slug (URL) *</FieldLabel>
        <div style={{ position:"relative" }}>
          <Input {...inp} placeholder="plantaeraiz" value={slug} onChange={e=>setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g,""))} />
        </div>
        <div style={{ fontSize:11, color:T.textMuted, marginBottom:4 }}>
          URL de acesso: <span style={{ color:T.accent, fontFamily:"monospace" }}>seusite.com/<b>{slug||"slug"}</b></span>
        </div>

        <SectionLabel T={T}>Google Agenda</SectionLabel>
        <FieldLabel T={T}>Link privado iCal (opcional)</FieldLabel>
        <Input {...inp} type="url" placeholder="https://calendar.google.com/calendar/ical/.../basic.ics" value={icalUrl} onChange={e=>setIcalUrl(e.target.value)} />
        <div style={{ fontSize:11, color:T.textMuted, marginBottom:4 }}>A agenda será importada automaticamente no início de cada hora. O título e toda a descrição do evento do Google são preservados. Opcionalmente use <b>TIPO: CONFIRMADO</b> e <b>PASSAGEM DE SOM: 17:00</b> na descrição.</div>
        {isEdit && (agenda.last_synced_at || agenda.last_sync_error) && <div style={{ fontSize:11, color:agenda.last_sync_error?T.danger:T.textMuted, marginTop:6 }}>{agenda.last_sync_error ? `Último erro: ${agenda.last_sync_error}` : `Última sincronização: ${agenda.last_synced_at} UTC`}</div>}
        {isEdit && <Btn T={T} variant="secondary" style={{ width:"100%", marginTop:10 }} onClick={syncNow} disabled={syncing || !icalUrl}>{syncing ? "SINCRONIZANDO..." : "SINCRONIZAR AGORA"}</Btn>}

        {!isEdit && <>
          <SectionLabel T={T}>Admin da agenda</SectionLabel>
          <FieldLabel T={T}>Usuario do admin *</FieldLabel>
          <Input {...inp} placeholder="admin_banda" value={adminU} onChange={e=>setAdminU(e.target.value)} />
          <FieldLabel T={T}>Senha do admin *</FieldLabel>
          <Input {...inp} type="password" placeholder="Senha segura" value={adminP} onChange={e=>setAdminP(e.target.value)} />
          <div style={{ fontSize:11, color:T.textMuted, marginTop:2 }}>Este usuario podera adicionar e editar shows.</div>
        </>}

        <Btn T={T} variant="primary" style={{ width:"100%", marginTop:20 }} onClick={save} disabled={saving}>
          {saving ? "SALVANDO..." : isEdit ? "SALVAR ALTERACOES" : "CRIAR AGENDA"}
        </Btn>
      </div>
    </div>
  );
}

// ── Users Panel ───────────────────────────────────────────────────────────────
function UsersPanel({ T, token, toast, agenda, onBack, isMobile, px }) {
  const [users,   setUsers]  = useState(agenda.users || []);
  const [newU,    setNewU]   = useState("");
  const [newP,    setNewP]   = useState("");
  const [newRole, setNewRole]= useState("user");
  const [saving,  setSaving] = useState(false);
  const [err,     setErr]    = useState("");
  const [resetId, setResetId]= useState(null);
  const [resetP,  setResetP] = useState("");

  async function addUser() {
    if (!newU || !newP) { setErr("Usuario e senha obrigatorios"); return; }
    setErr(""); setSaving(true);
    try {
      const u = await api.addUser(agenda.id, { username:newU, password:newP, role:newRole }, token);
      setUsers(p=>[...p, u]); setNewU(""); setNewP(""); toast("Usuario adicionado");
    } catch(e) { setErr(e.message); }
    finally { setSaving(false); }
  }

  async function removeUser(id) {
    if (!window.confirm("Remover usuario?")) return;
    try { await api.deleteUser(id, token); setUsers(p=>p.filter(u=>u.id!==id)); toast("Usuario removido"); }
    catch(e) { toast(e.message); }
  }

  async function doReset() {
    if (!resetP || resetP.length < 4) { toast("Senha muito curta"); return; }
    try { await api.resetPass(resetId, resetP, token); setResetId(null); setResetP(""); toast("Senha redefinida"); }
    catch(e) { toast(e.message); }
  }

  const inp = { T, style:{ marginBottom:4 } };

  return (
    <div style={{ paddingBottom:60 }}>
      {resetId && (
        <div style={{ position:"fixed", inset:0, background:T.modalBg, zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }} onClick={()=>setResetId(null)}>
          <div style={{ background:T.surface, borderRadius:14, padding:24, width:"100%", maxWidth:320, boxShadow:`0 8px 32px ${T.shadowMd}` }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontWeight:800, fontSize:15, color:T.text, marginBottom:12 }}>Nova senha</div>
            <Input T={T} type="password" placeholder="Nova senha" value={resetP} onChange={e=>setResetP(e.target.value)} style={{ marginBottom:12 }} />
            <div style={{ display:"flex", gap:10 }}>
              <Btn T={T} variant="secondary" style={{ flex:1 }} onClick={()=>setResetId(null)}>Cancelar</Btn>
              <Btn T={T} variant="primary"   style={{ flex:1 }} onClick={doReset}>Salvar</Btn>
            </div>
          </div>
        </div>
      )}

      <PageHeader T={T} onBack={onBack} title={`Usuarios — ${agenda.name}`} px={px} />
      <div style={{ padding:`0 ${px}px 24px` }}>
        <SectionLabel T={T}>Adicionar usuario</SectionLabel>
        {err && <div style={{ background:"rgba(211,47,47,0.1)", border:`1px solid ${T.danger}`, borderRadius:8, padding:"8px 12px", margin:"8px 0", fontSize:12, color:T.danger }}>{err}</div>}
        <FieldLabel T={T}>Usuario</FieldLabel>
        <Input {...inp} placeholder="usuario_banda" value={newU} onChange={e=>setNewU(e.target.value)} />
        <FieldLabel T={T}>Senha</FieldLabel>
        <Input {...inp} type="password" placeholder="Senha" value={newP} onChange={e=>setNewP(e.target.value)} />
        <FieldLabel T={T}>Papel</FieldLabel>
        <select value={newRole} onChange={e=>setNewRole(e.target.value)}
          style={{ width:"100%", background:T.inputBg, border:`1.5px solid ${T.inputBorder}`, borderRadius:9, padding:"11px 13px", fontSize:14, color:T.text, outline:"none", marginBottom:4, cursor:"pointer" }}>
          <option value="user">user — so visualiza</option>
          <option value="admin">admin — pode editar shows</option>
        </select>
        <Btn T={T} variant="primary" style={{ width:"100%", marginTop:10 }} onClick={addUser} disabled={saving}>
          <I n="Plus" size={15} /> {saving?"ADICIONANDO...":"ADICIONAR USUARIO"}
        </Btn>

        <SectionLabel T={T}>Usuarios ({users.length})</SectionLabel>
        {users.length === 0
          ? <p style={{ color:T.textMuted, fontSize:13, padding:"12px 0" }}>Nenhum usuario ainda.</p>
          : users.map(u => (
            <div key={u.id} style={{ background:T.surface, borderRadius:10, padding:"12px 14px", marginBottom:8, border:`1px solid ${T.border}`, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
              <div>
                <div style={{ fontSize:14, fontWeight:700, color:T.text }}>{u.username}</div>
                <div style={{ fontSize:11, color:T.textMuted, marginTop:1 }}>{u.role}</div>
              </div>
              <div style={{ display:"flex", gap:6 }}>
                <Btn T={T} variant="secondary" style={{ fontSize:11, padding:"6px 10px" }} onClick={()=>{ setResetId(u.id); setResetP(""); }}>
                  <I n="Key" size={13} />
                </Btn>
                <Btn T={T} variant="danger" style={{ fontSize:11, padding:"6px 10px" }} onClick={()=>removeUser(u.id)}>
                  <I n="Trash" size={13} />
                </Btn>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

function ib(T) { return { background:"none", border:"none", cursor:"pointer", color:T.headerText, padding:7, borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center" }; }
